var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "佣金设置：", props: "isSub" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.isDisabled },
                      on: {
                        change: function ($event) {
                          return _vm.onChangetype(_vm.formValidate.isSub)
                        },
                      },
                      model: {
                        value: _vm.formValidate.isSub,
                        callback: function ($$v) {
                          _vm.$set(_vm.formValidate, "isSub", $$v)
                        },
                        expression: "formValidate.isSub",
                      },
                    },
                    [
                      _c(
                        "el-radio",
                        { staticClass: "radio", attrs: { label: true } },
                        [_vm._v("单独设置")]
                      ),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("默认设置"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "规格类型：", props: "specType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.isDisabled },
                      on: {
                        change: function ($event) {
                          return _vm.onChangeSpec(_vm.formValidate.specType)
                        },
                      },
                      model: {
                        value: _vm.formValidate.specType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formValidate, "specType", $$v)
                        },
                        expression: "formValidate.specType",
                      },
                    },
                    [
                      _c(
                        "el-radio",
                        { staticClass: "radio", attrs: { label: false } },
                        [_vm._v("单规格")]
                      ),
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("多规格"),
                      ]),
                    ],
                    1
                  ),
                  _vm.formValidate.specType && _vm.ruleList.length
                    ? _c(
                        "el-dropdown",
                        {
                          staticClass: "ml20 dropdown-menu-box",
                          attrs: { disabled: _vm.isDisabled, trigger: "hover" },
                          on: { command: _vm.confirmAttrTemp },
                        },
                        [
                          _c("span", { staticClass: "el-dropdown-link" }, [
                            _vm._v(" 选择规格模板"),
                            _c("i", {
                              staticClass: "el-icon-arrow-down el-icon--right",
                            }),
                          ]),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            _vm._l(_vm.ruleList, function (item, index) {
                              return _c(
                                "el-dropdown-item",
                                {
                                  key: index,
                                  attrs: { command: item.ruleName },
                                },
                                [_vm._v(" " + _vm._s(item.ruleName) + " ")]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.formValidate.specType && !_vm.isDisabled
            ? _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-form-item", { attrs: { label: "商品规格：" } }, [
                    _vm.formValidate.attr.length
                      ? _c("div", { staticClass: "attr-tips from-tips mb20" }, [
                          _vm._v(" 勾选添加规格图，当前规格图片必须上传 "),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "specifications" },
                      [
                        _c(
                          "draggable",
                          {
                            attrs: {
                              group: "specifications",
                              disabled: _vm.formValidate.attr.length < 2,
                              list: _vm.formValidate.attr,
                              handle: ".attr-move-icon",
                              animation: "300",
                            },
                            on: {
                              end: function ($event) {
                                return _vm.onMoveSpec($event, "attr")
                              },
                            },
                          },
                          _vm._l(_vm.formValidate.attr, function (item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "specifications-item active",
                                on: {
                                  click: function ($event) {
                                    return _vm.changeCurrentIndex(index)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "attr-move-icon" }, [
                                  _c("span", {
                                    staticClass: "iconfont icondrag2",
                                  }),
                                ]),
                                _c("i", {
                                  staticClass: "del el-icon-error",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleRemoveAttr(index)
                                    },
                                  },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "specifications-item-box" },
                                  [
                                    _c("div", { staticClass: "lineBox" }),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "specifications-item-name mb18",
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass:
                                            "specifications-item-name-input attr-input w-240",
                                          attrs: {
                                            size: "small",
                                            placeholder: "规格名称",
                                            maxlength: "30",
                                            "show-word-limit": "",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.changeAttr(
                                                index,
                                                item.attrName
                                              )
                                            },
                                            focus: function ($event) {
                                              return _vm.handleFocus(
                                                item.attrName
                                              )
                                            },
                                          },
                                          model: {
                                            value: item.attrName,
                                            callback: function ($$v) {
                                              _vm.$set(item, "attrName", $$v)
                                            },
                                            expression: "item.attrName",
                                          },
                                        }),
                                        _c(
                                          "el-checkbox",
                                          {
                                            staticClass: "ml20",
                                            attrs: {
                                              disabled:
                                                !item.isShowImage &&
                                                !_vm.canSel,
                                              "true-label": 1,
                                              "false-label": 0,
                                            },
                                            on: {
                                              change: function (e) {
                                                return _vm.addPic(e, index)
                                              },
                                            },
                                            model: {
                                              value: item.isShowImage,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "isShowImage",
                                                  $$v
                                                )
                                              },
                                              expression: "item.isShowImage",
                                            },
                                          },
                                          [_vm._v("添加规格图")]
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              content:
                                                "添加规格图片, 仅支持打开一个(建议尺寸:800*800),勾选后,当前规格图片必须上传",
                                              placement: "right",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-info",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "rulesBox ml30" },
                                      [
                                        _c(
                                          "draggable",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              list: item.optionList,
                                              disabled:
                                                item.optionList.length < 2,
                                              handle: ".value-move-icon",
                                            },
                                            on: {
                                              end: function ($event) {
                                                return _vm.onMoveSpec(
                                                  $event,
                                                  index,
                                                  "value"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._l(
                                              item.optionList,
                                              function (det, indexn) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: indexn,
                                                    staticClass: "mr10 spec",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-error",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleRemoveValue(
                                                            item,
                                                            indexn,
                                                            det.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "el-input",
                                                      {
                                                        staticClass:
                                                          "attr-input w-240",
                                                        attrs: {
                                                          size: "small",
                                                          placeholder: "规格值",
                                                          maxlength: "30",
                                                          "show-word-limit": "",
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            return _vm.changeValue(
                                                              det.value,
                                                              index,
                                                              indexn
                                                            )
                                                          },
                                                          focus: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleFocus(
                                                              det.value
                                                            )
                                                          },
                                                          blur: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleBlur()
                                                          },
                                                        },
                                                        model: {
                                                          value: det.value,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              det,
                                                              "value",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "det.value",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "template",
                                                          { slot: "prefix" },
                                                          [
                                                            _c("span", {
                                                              staticClass:
                                                                "iconfont icondrag2 value-move-icon",
                                                            }),
                                                          ]
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                    item.isShowImage
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "img-popover",
                                                          },
                                                          [
                                                            _c("div", {
                                                              staticClass:
                                                                "popper-arrow",
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "popper",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleSelImg(
                                                                        det,
                                                                        indexn
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                det.image
                                                                  ? _c(
                                                                      "el-image",
                                                                      {
                                                                        staticClass:
                                                                          "image",
                                                                        attrs: {
                                                                          src: det.image,
                                                                          fit: "cover",
                                                                        },
                                                                      }
                                                                    )
                                                                  : _c("i", {
                                                                      staticClass:
                                                                        "el-icon-plus",
                                                                    }),
                                                              ],
                                                              1
                                                            ),
                                                            det.image
                                                              ? _c("i", {
                                                                  staticClass:
                                                                    "img-del el-icon-error",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleRemoveImg(
                                                                          det
                                                                        )
                                                                      },
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-popover",
                                                  {
                                                    ref: "popoverRef_" + index,
                                                    refInFor: true,
                                                    attrs: {
                                                      placement: "",
                                                      width: "240",
                                                      trigger: "click",
                                                    },
                                                    on: {
                                                      "after-enter": function (
                                                        $event
                                                      ) {
                                                        return _vm.handleShowPop(
                                                          index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      ref: "inputRef_" + index,
                                                      refInFor: true,
                                                      staticClass:
                                                        "attr-input w-240",
                                                      attrs: {
                                                        size: "small",
                                                        placeholder:
                                                          "请输入规格值",
                                                        maxlength: "30",
                                                        "show-word-limit": "",
                                                      },
                                                      on: {
                                                        blur: function (
                                                          $event
                                                        ) {
                                                          return _vm.createAttr(
                                                            _vm.formDynamic
                                                              .attrsVal,
                                                            index
                                                          )
                                                        },
                                                      },
                                                      nativeOn: {
                                                        keyup: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            !$event.type.indexOf(
                                                              "key"
                                                            ) &&
                                                            _vm._k(
                                                              $event.keyCode,
                                                              "enter",
                                                              13,
                                                              $event.key,
                                                              "Enter"
                                                            )
                                                          ) {
                                                            return null
                                                          }
                                                          return _vm.createAttr(
                                                            _vm.formDynamic
                                                              .attrsVal,
                                                            index
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.formDynamic
                                                            .attrsVal,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.formDynamic,
                                                            "attrsVal",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "formDynamic.attrsVal",
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "addfont",
                                                        attrs: {
                                                          slot: "reference",
                                                        },
                                                        slot: "reference",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            attrs: {
                                                              slot: "reference",
                                                            },
                                                            slot: "reference",
                                                          },
                                                          [_vm._v("添加规格值")]
                                                        ),
                                                      ]
                                                    ),
                                                    _c("div", {
                                                      staticClass: "empty-box",
                                                      attrs: {
                                                        slot: "reference",
                                                      },
                                                      slot: "reference",
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c("el-button", { on: { click: _vm.handleAddRole } }, [
                          _vm._v("添加新规格"),
                        ]),
                        _vm.formValidate.attr.length >= 1
                          ? _c(
                              "el-button",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleSaveAsTemplate()
                                  },
                                },
                              },
                              [_vm._v("另存为模板")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { xl: 24, lg: 24, md: 24, sm: 24, xs: 24 } },
            [
              _vm.formValidate.specType === false
                ? _c(
                    "el-form-item",
                    [
                      _c(
                        "el-table",
                        {
                          staticClass: "tabNumWidth",
                          attrs: {
                            data: _vm.OneattrValue,
                            border: "",
                            size: "mini",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "图片", "min-width": "60" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "upLoadPicBox",
                                          on: {
                                            click: function ($event) {
                                              return _vm.modalPicTap("1", "dan")
                                            },
                                          },
                                        },
                                        [
                                          _vm.formValidate.image
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "pictrue tabPic",
                                                },
                                                [
                                                  _c("el-image", {
                                                    attrs: {
                                                      "preview-src-list":
                                                        _vm.isDisabled
                                                          ? [scope.row.image]
                                                          : [],
                                                      src: _vm.OneattrValue[0]
                                                        .image,
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticClass: "upLoad tabPic",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-camera cameraIconfont",
                                                  }),
                                                ]
                                              ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4223710079
                            ),
                          }),
                          _vm.formValidate.isSub
                            ? [
                                _c(
                                  "el-table-column",
                                  {
                                    attrs: {
                                      label: "一级返佣(%)",
                                      "min-width": "100",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: _vm.isDisabled },
                                      model: {
                                        value: _vm.OneattrValue[0].brokerage,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.OneattrValue[0],
                                            "brokerage",
                                            $$v
                                          )
                                        },
                                        expression: "OneattrValue[0].brokerage",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-table-column",
                                  {
                                    attrs: {
                                      label: "二级返佣(%)",
                                      "min-width": "100",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: _vm.isDisabled },
                                      model: {
                                        value: _vm.OneattrValue[0].brokerageTwo,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.OneattrValue[0],
                                            "brokerageTwo",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "OneattrValue[0].brokerageTwo",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                          _vm._l(_vm.oneAttrTableTitle, function (item, iii) {
                            return _c("el-table-column", {
                              key: iii,
                              attrs: {
                                label: item.title,
                                "min-width": item.minWidth || "200",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return item.slot != "isDefault" &&
                                        item.slot != "action"
                                        ? [
                                            _c("el-input", {
                                              staticClass: "priceBox",
                                              attrs: {
                                                disabled: _vm.isDisabled,
                                                type:
                                                  item.title === "商品编号"
                                                    ? "text"
                                                    : "number",
                                                min: 0,
                                              },
                                              nativeOn: {
                                                keyup: function ($event) {
                                                  return _vm.keyupEvent(
                                                    iii,
                                                    scope.row[iii],
                                                    scope.$index,
                                                    2
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.OneattrValue[0][
                                                    item.slot
                                                  ],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.OneattrValue[0],
                                                    item.slot,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "OneattrValue[0][item.slot]",
                                              },
                                            }),
                                          ]
                                        : undefined
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formValidate.attr.length > 0 && _vm.formValidate.specType
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "labeltop",
                      class: _vm.isDisabled ? "disLabel" : "disLabelmoren",
                      attrs: { label: "商品属性：" },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          key: _vm.tableKey,
                          staticClass: "tabNumWidth",
                          attrs: {
                            data: _vm.ManyAttrValue,
                            border: "",
                            size: "small",
                            "span-method": _vm.objectSpanMethod,
                            "cell-class-name": _vm.tableCellClassName,
                          },
                        },
                        [
                          _vm.formValidate.header
                            ? _vm._l(
                                _vm.formValidate.header,
                                function (item, iii) {
                                  return _c("el-table-column", {
                                    key: iii,
                                    attrs: {
                                      label: item.title,
                                      "min-width": item.minWidth || "200",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.$index == 0
                                                ? [
                                                    item.key
                                                      ? [
                                                          _vm.formValidate.attr
                                                            .length &&
                                                          _vm.formValidate.attr[
                                                            iii
                                                          ] &&
                                                          _vm.ManyAttrValue
                                                            .length
                                                            ? _c(
                                                                "div",
                                                                [
                                                                  _c(
                                                                    "el-select",
                                                                    {
                                                                      attrs: {
                                                                        placeholder:
                                                                          "请选择" +
                                                                          item.title,
                                                                        clearable:
                                                                          "",
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .oneFormBatch[0][
                                                                            item
                                                                              .title
                                                                          ],
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm
                                                                                .oneFormBatch[0],
                                                                              item.title,
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "oneFormBatch[0][item.title]",
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm
                                                                        .formValidate
                                                                        .attr[
                                                                        iii
                                                                      ]
                                                                        .optionList,
                                                                      function (
                                                                        val,
                                                                        valIdx
                                                                      ) {
                                                                        return _c(
                                                                          "el-option",
                                                                          {
                                                                            key: valIdx,
                                                                            attrs:
                                                                              {
                                                                                label:
                                                                                  val.value,
                                                                                value:
                                                                                  val.value,
                                                                              },
                                                                          }
                                                                        )
                                                                      }
                                                                    ),
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      : item.slot === "image"
                                                      ? [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "upLoadPicBox",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.modalPicTap(
                                                                      "1",
                                                                      "pi",
                                                                      scope.$index
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm
                                                                .oneFormBatch[0]
                                                                .image
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "pictrue tabPic",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "el-image",
                                                                        {
                                                                          staticClass:
                                                                            "preview-src",
                                                                          attrs:
                                                                            {
                                                                              "preview-src-list":
                                                                                _vm.isDisabled
                                                                                  ? [
                                                                                      scope
                                                                                        .row
                                                                                        .image,
                                                                                    ]
                                                                                  : [],
                                                                              src: _vm
                                                                                .oneFormBatch[0]
                                                                                .image,
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "upLoad tabPic",
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "el-icon-camera cameraIconfont",
                                                                      }),
                                                                    ]
                                                                  ),
                                                            ]
                                                          ),
                                                        ]
                                                      : item.slot === "price"
                                                      ? [
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              staticClass:
                                                                "priceBox",
                                                              attrs: {
                                                                controls: false,
                                                                min: 0,
                                                                max: 999999.99,
                                                                disabled:
                                                                  _vm.isDisabled,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .oneFormBatch[0]
                                                                    .price,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .oneFormBatch[0],
                                                                      "price",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "oneFormBatch[0].price",
                                                              },
                                                            }
                                                          ),
                                                        ]
                                                      : item.slot === "cost"
                                                      ? [
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              staticClass:
                                                                "priceBox",
                                                              attrs: {
                                                                controls: false,
                                                                min: 0,
                                                                max: 999999.99,
                                                                disabled:
                                                                  _vm.isDisabled,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .oneFormBatch[0]
                                                                    .cost,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .oneFormBatch[0],
                                                                      "cost",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "oneFormBatch[0].cost",
                                                              },
                                                            }
                                                          ),
                                                        ]
                                                      : item.slot === "otPrice"
                                                      ? [
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              staticClass:
                                                                "priceBox",
                                                              attrs: {
                                                                controls: false,
                                                                min: 0,
                                                                max: 999999.99,
                                                                disabled:
                                                                  _vm.isDisabled,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .oneFormBatch[0]
                                                                    .otPrice,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .oneFormBatch[0],
                                                                      "otPrice",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "oneFormBatch[0].otPrice",
                                                              },
                                                            }
                                                          ),
                                                        ]
                                                      : item.slot === "stock"
                                                      ? [
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              staticClass:
                                                                "priceBox",
                                                              attrs: {
                                                                controls: false,
                                                                min: 0,
                                                                max: 999999,
                                                                precision: 0,
                                                                disabled:
                                                                  _vm.isDisabled,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .oneFormBatch[0]
                                                                    .stock,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .oneFormBatch[0],
                                                                      "stock",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "oneFormBatch[0].stock",
                                                              },
                                                            }
                                                          ),
                                                        ]
                                                      : item.slot === "barCode"
                                                      ? [
                                                          _c("el-input", {
                                                            staticClass:
                                                              "priceBox",
                                                            attrs: {
                                                              maxlength: "40",
                                                              disabled:
                                                                _vm.isDisabled,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .oneFormBatch[0]
                                                                  .barCode,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .oneFormBatch[0],
                                                                    "barCode",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "oneFormBatch[0].barCode",
                                                            },
                                                          }),
                                                        ]
                                                      : item.slot ===
                                                          "brokerage" &&
                                                        _vm.formValidate.isSub
                                                      ? [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.isDisabled,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .oneFormBatch[0]
                                                                  .brokerage,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .oneFormBatch[0],
                                                                    "brokerage",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "oneFormBatch[0].brokerage",
                                                            },
                                                          }),
                                                        ]
                                                      : item.slot ===
                                                          "brokerageTwo" &&
                                                        _vm.formValidate.isSub
                                                      ? [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.isDisabled,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .oneFormBatch[0]
                                                                  .brokerageTwo,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .oneFormBatch[0],
                                                                    "brokerageTwo",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "oneFormBatch[0].brokerageTwo",
                                                            },
                                                          }),
                                                        ]
                                                      : item.slot === "weight"
                                                      ? [
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              staticClass:
                                                                "priceBox",
                                                              attrs: {
                                                                controls: false,
                                                                step: 0.1,
                                                                max: 999999,
                                                                disabled:
                                                                  _vm.isDisabled,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .oneFormBatch[0]
                                                                    .weight,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .oneFormBatch[0],
                                                                      "weight",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "oneFormBatch[0].weight",
                                                              },
                                                            }
                                                          ),
                                                        ]
                                                      : item.slot === "volume"
                                                      ? [
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              staticClass:
                                                                "priceBox",
                                                              attrs: {
                                                                controls: false,
                                                                step: 0.1,
                                                                min: 0,
                                                                max: 999999,
                                                                disabled:
                                                                  _vm.isDisabled,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .oneFormBatch[0]
                                                                    .volume,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .oneFormBatch[0],
                                                                      "volume",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "oneFormBatch[0].volume",
                                                              },
                                                            }
                                                          ),
                                                        ]
                                                      : item.slot ===
                                                        "isDefault"
                                                      ? [_vm._v(" -- ")]
                                                      : item.slot === "action"
                                                      ? [
                                                          _c(
                                                            "a",
                                                            {
                                                              attrs: {
                                                                type: "text",
                                                                size: "mini",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.batchAdd,
                                                              },
                                                            },
                                                            [_vm._v("批量修改")]
                                                          ),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "ml10",
                                                              attrs: {
                                                                type: "text",
                                                                size: "mini",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.batchDel,
                                                              },
                                                            },
                                                            [_vm._v("清空")]
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                  ]
                                                : [
                                                    item.key
                                                      ? [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "text-center",
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scope.row[
                                                                      item.key
                                                                    ]
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]
                                                      : item.slot === "image"
                                                      ? [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "upLoadPicBox",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.modalPicTap(
                                                                      "1",
                                                                      "duo",
                                                                      scope.$index
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              scope.row.image
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "pictrue tabPic",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "el-image",
                                                                        {
                                                                          staticClass:
                                                                            "preview-src",
                                                                          attrs:
                                                                            {
                                                                              "preview-src-list":
                                                                                _vm.isDisabled
                                                                                  ? [
                                                                                      scope
                                                                                        .row
                                                                                        .image,
                                                                                    ]
                                                                                  : [],
                                                                              src: scope
                                                                                .row
                                                                                .image,
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "upLoad tabPic",
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "el-icon-camera cameraIconfont",
                                                                      }),
                                                                    ]
                                                                  ),
                                                            ]
                                                          ),
                                                        ]
                                                      : item.slot === "price"
                                                      ? [
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              staticClass:
                                                                "priceBox",
                                                              attrs: {
                                                                controls: false,
                                                                min: 0,
                                                                max: 999999.99,
                                                                disabled:
                                                                  _vm.isDisabled,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .ManyAttrValue[
                                                                    scope.$index
                                                                  ].price,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .ManyAttrValue[
                                                                        scope
                                                                          .$index
                                                                      ],
                                                                      "price",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "ManyAttrValue[scope.$index].price",
                                                              },
                                                            }
                                                          ),
                                                        ]
                                                      : item.slot === "cost"
                                                      ? [
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              staticClass:
                                                                "priceBox",
                                                              attrs: {
                                                                controls: false,
                                                                min: 0,
                                                                max: 999999.99,
                                                                disabled:
                                                                  _vm.isDisabled,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .ManyAttrValue[
                                                                    scope.$index
                                                                  ].cost,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .ManyAttrValue[
                                                                        scope
                                                                          .$index
                                                                      ],
                                                                      "cost",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "ManyAttrValue[scope.$index].cost",
                                                              },
                                                            }
                                                          ),
                                                        ]
                                                      : item.slot === "otPrice"
                                                      ? [
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              staticClass:
                                                                "priceBox",
                                                              attrs: {
                                                                controls: false,
                                                                min: 0,
                                                                max: 999999.99,
                                                                disabled:
                                                                  _vm.isDisabled,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .ManyAttrValue[
                                                                    scope.$index
                                                                  ].otPrice,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .ManyAttrValue[
                                                                        scope
                                                                          .$index
                                                                      ],
                                                                      "otPrice",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "ManyAttrValue[scope.$index].otPrice",
                                                              },
                                                            }
                                                          ),
                                                        ]
                                                      : item.slot === "stock"
                                                      ? [
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              staticClass:
                                                                "priceBox",
                                                              attrs: {
                                                                controls: false,
                                                                min: 0,
                                                                max: 999999,
                                                                precision: 0,
                                                                disabled:
                                                                  _vm.isDisabled,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .ManyAttrValue[
                                                                    scope.$index
                                                                  ].stock,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .ManyAttrValue[
                                                                        scope
                                                                          .$index
                                                                      ],
                                                                      "stock",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "ManyAttrValue[scope.$index].stock",
                                                              },
                                                            }
                                                          ),
                                                        ]
                                                      : item.slot === "barCode"
                                                      ? [
                                                          _c("el-input", {
                                                            staticClass:
                                                              "priceBox",
                                                            attrs: {
                                                              maxlength: "40",
                                                              disabled:
                                                                _vm.isDisabled,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .ManyAttrValue[
                                                                  scope.$index
                                                                ].barCode,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .ManyAttrValue[
                                                                      scope
                                                                        .$index
                                                                    ],
                                                                    "barCode",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "ManyAttrValue[scope.$index].barCode",
                                                            },
                                                          }),
                                                        ]
                                                      : item.slot ===
                                                          "brokerage" &&
                                                        _vm.formValidate.isSub
                                                      ? [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.isDisabled,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .ManyAttrValue[
                                                                  scope.$index
                                                                ].brokerage,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .ManyAttrValue[
                                                                      scope
                                                                        .$index
                                                                    ],
                                                                    "brokerage",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "ManyAttrValue[scope.$index].brokerage",
                                                            },
                                                          }),
                                                        ]
                                                      : item.slot ===
                                                          "brokerageTwo" &&
                                                        _vm.formValidate.isSub
                                                      ? [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.isDisabled,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .ManyAttrValue[
                                                                  scope.$index
                                                                ].brokerageTwo,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .ManyAttrValue[
                                                                      scope
                                                                        .$index
                                                                    ],
                                                                    "brokerageTwo",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "ManyAttrValue[scope.$index].brokerageTwo",
                                                            },
                                                          }),
                                                        ]
                                                      : item.slot === "weight"
                                                      ? [
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              staticClass:
                                                                "priceBox",
                                                              attrs: {
                                                                controls: false,
                                                                step: 0.1,
                                                                max: 999999,
                                                                disabled:
                                                                  _vm.isDisabled,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .ManyAttrValue[
                                                                    scope.$index
                                                                  ].weight,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .ManyAttrValue[
                                                                        scope
                                                                          .$index
                                                                      ],
                                                                      "weight",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "ManyAttrValue[scope.$index].weight",
                                                              },
                                                            }
                                                          ),
                                                        ]
                                                      : item.slot === "volume"
                                                      ? [
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              staticClass:
                                                                "priceBox",
                                                              attrs: {
                                                                controls: false,
                                                                step: 0.1,
                                                                min: 0,
                                                                max: 999999,
                                                                disabled:
                                                                  _vm.isDisabled,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .ManyAttrValue[
                                                                    scope.$index
                                                                  ].volume,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .ManyAttrValue[
                                                                        scope
                                                                          .$index
                                                                      ],
                                                                      "volume",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "ManyAttrValue[scope.$index].volume",
                                                              },
                                                            }
                                                          ),
                                                        ]
                                                      : item.slot ===
                                                        "isDefault"
                                                      ? [
                                                          _c("el-switch", {
                                                            attrs: {
                                                              "active-value": true,
                                                              "inactive-value": false,
                                                              "active-text":
                                                                "默认",
                                                              disabled:
                                                                _vm.isDisabled,
                                                            },
                                                            on: {
                                                              change: function (
                                                                e
                                                              ) {
                                                                return _vm.changeDefaultSelect(
                                                                  e,
                                                                  scope.$index
                                                                )
                                                              },
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .ManyAttrValue[
                                                                  scope.$index
                                                                ].isDefault,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .ManyAttrValue[
                                                                      scope
                                                                        .$index
                                                                    ],
                                                                    "isDefault",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "ManyAttrValue[scope.$index].isDefault",
                                                            },
                                                          }),
                                                        ]
                                                      : item.slot === "action"
                                                      ? [
                                                          _c("el-switch", {
                                                            staticClass:
                                                              "defineSwitch",
                                                            attrs: {
                                                              "active-text":
                                                                "显示",
                                                              "inactive-text":
                                                                "隐藏",
                                                              "active-value": true,
                                                              "inactive-value": false,
                                                              disabled:
                                                                _vm.isDisabled,
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.changeDefaultShow(
                                                                  scope.$index
                                                                )
                                                              },
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .ManyAttrValue[
                                                                  scope.$index
                                                                ].isShow,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .ManyAttrValue[
                                                                      scope
                                                                        .$index
                                                                    ],
                                                                    "isShow",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "ManyAttrValue[scope.$index].isShow",
                                                            },
                                                          }),
                                                        ]
                                                      : _vm._e(),
                                                  ],
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                }
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }